import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Assortment} from '../../entities/assortment.model';

@Injectable()
export class AssortmentService {
  private assortments: Assortment[];

  private assortmentMap: Map<string, Assortment> = new Map<string, Assortment>();

  constructor(private apiService: ApiService) {
    this.getAssortments().then((assortments) => this.assortments = assortments);
  }

  getAssortments(): Promise<Assortment[]> {
    return new Promise((resolve, reject) => {
      this.apiService.find<Assortment>(Assortment, 'assortments').subscribe(
        (assortments) => {
          this.assortments = assortments;
          assortments.forEach( assortment => this.assortmentMap.set(assortment.keyNumber, assortment));
          resolve(assortments);
        }, () => {
          reject(-1);
        });
    });
  }

  getAssortment(key: string) {
    return this.assortmentMap.get(key);
  }

  getAssortmentsWithSeparator(keys: string[], separator = ', ') {
    let result = '';
    if (keys) {
      for (let i = 0; i < keys.length; i++) {
        result += this.getAssortment(keys[i]).title;
        if (i < keys.length - 1) {
          result += separator;
        }
      }
    }
    return result;
  }

  getAssortmentByIndustrialCode(code: string) {
    return new Promise<Assortment[]>(
      resolve => {
        if (this.assortments) {
          resolve(this.assortments.filter( (assortment) => assortment.industrialCode === code ));
        } else {
          this.getAssortments().then(
            () => {
              resolve(this.assortments.filter( (assortment) => assortment.industrialCode === code ));
            }
          );
        }
      }
    );
  }

  assortmentsToKeyString(assortments, onlyChecked = true) {
    let keys = '';
    if (assortments) {
      assortments.map(assortment => keys += (assortment.checked) ? assortment.keyNumber + ', ' : '');
      keys = keys.substring(0, keys.length - 2);
    }
    return keys;
  }

  assortmentsFromKeyStrings(assortmentKeys: string[]) {
    const assortments = [];
    assortmentKeys.forEach(
      (key) => {
        assortments.push(this.getAssortment(key));
      }
    );
    return assortments;
  }

  assortmentTypeFromKeyStrings(assortmentKeys: string[]): string {
    let assortmentType = '67/1';
    if (assortmentKeys) {
      assortmentKeys.forEach(
        (key) => {
          const assortment = this.getAssortment(key);
          if (assortment.industrialCode !== assortmentType) {
            assortmentType = '67/2';
          }
        }
      );
    }
    return assortmentType;
  }

  selectAssortments(assortmentKeys: string[]): Assortment[] {
    const assortments = JSON.parse(JSON.stringify(this.assortments));
    assortments.map(assortment => assortment.checked = assortmentKeys.includes(assortment.keyNumber));
    return assortments;
  }

  selectAssortmentsFromString(assortmentKeysString: string) {
    let assortmentKeys = null;
    if (assortmentKeysString) {
      assortmentKeys = assortmentKeysString.replace(/\s+/g, '').split(',');
      return this.selectAssortments(assortmentKeys);
    } else {
      return null;
    }
  }

  assortmentKeyStringArrayFromString(assortmentKeysString: string) {
    return assortmentKeysString.replace(/\s+/g, '').split(',');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/assortment.service.ts